import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ 
  title, 
  value, 
  trend, 
  trendValue, 
  icon, 
  sparklineData = [],
  format = 'number',
  status = 'neutral'
}) => {
  const formatValue = (val) => {
    if (format === 'currency') {
      return `Rp ${val?.toLocaleString('id-ID')}`;
    }
    if (format === 'percentage') {
      return `${val}%`;
    }
    return val?.toLocaleString('id-ID');
  };

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'text-success';
      case 'warning':
        return 'text-warning';
      case 'error':
        return 'text-error';
      default:
        return 'text-foreground';
    }
  };

  const getTrendColor = () => {
    return trend === 'up' ? 'text-success' : trend === 'down' ? 'text-error' : 'text-muted-foreground';
  };

  const maxSparkline = Math.max(...sparklineData);
  const minSparkline = Math.min(...sparklineData);
  const range = maxSparkline - minSparkline || 1;

  return (
    <div className="card hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1 font-medium">{title}</p>
          <h3 className={`text-2xl md:text-3xl lg:text-4xl font-semibold ${getStatusColor()}`}>
            {formatValue(value)}
          </h3>
        </div>
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
      </div>
      {sparklineData?.length > 0 && (
        <div className="mb-3 h-12 flex items-end gap-1">
          {sparklineData?.map((point, index) => {
            const height = ((point - minSparkline) / range) * 100;
            return (
              <div
                key={index}
                className="flex-1 bg-primary/20 rounded-t transition-all duration-300 hover:bg-primary/40"
                style={{ height: `${Math.max(height, 5)}%` }}
              />
            );
          })}
        </div>
      )}
      {trend && (
        <div className="flex items-center gap-2">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={getTrendColor()}
          />
          <span className={`text-sm font-medium ${getTrendColor()}`}>
            {trendValue}
          </span>
          <span className="text-xs text-muted-foreground">vs periode sebelumnya</span>
        </div>
      )}
    </div>
  );
};

export default KPICard;